import { Modifier, EditorState } from 'draft-js';

export const onReturn = (editorState, cb) => {
  const selection = editorState.getSelection();

  if (!selection.isCollapsed()) {
    return 'not-handled';
  }

  const content = editorState.getCurrentContent();
  const block = content.getBlockForKey(selection.getStartKey());
  const blockType = block.getType();

  if (
    blockType === 'header-one' ||
    blockType === 'header-two' ||
    blockType === 'header-three'
  ) {
    const newContent = Modifier.splitBlock(content, selection);
    const withNewBlock = EditorState.push(
      editorState,
      newContent,
      'split-block'
    );

    const targetSelection = withNewBlock.getSelection().merge({
      anchorOffset: 0,
      focusOffset: 0,
    });

    const withoutStyle = Modifier.setBlockType(
      withNewBlock.getCurrentContent(),
      targetSelection,
      'unstyled'
    );

    const withClearedStyle = EditorState.push(
      withNewBlock,
      withoutStyle,
      'change-block-type'
    );

    cb(withClearedStyle);

    return 'handled';
  }

  return 'not-handled';
};
